import { Campaign, LogService, Tip } from '@hub/shared'
import { Metric } from '@hub/shared/interfaces/metrics.interface'
import { SqMetricChartCard } from '@squidit/react-css'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CampaingMediaReachComponent from '../campaign-media-reach/campaign-media-reach.component'
import './content-metric-type.component.scoped.scss'

interface Props {
  campaign: Campaign
  metricType: string
  metric: Metric
  mediaTypes?: Array<string>
  socialId?: string
  mainMetric?: boolean
  percent?: boolean
}

export default ({
  campaign,
  metricType,
  metric,
  socialId,
  mainMetric = false,
  mediaTypes = ['posts', 'stories'],
  percent = false,
}: Props) => {
  const [t] = useTranslation('reportPage')
  const logService = useMemo(() => new LogService(), [])
  logService.init('Content metric type Component')

  return (
    <div className="content-type-metric">
      <h5>
        {mainMetric ? <i className="lg mr-2 fa-regular fa-bullseye-arrow" style={{ color: 'var(--primary_color)' }}></i> : null}
        {t(`${metricType}.title`)}
        <Tip className="ml-2" message={t(`${metricType}.helpText`)} place="top" icon={'fa-regular fa-circle-info'} />
      </h5>

      {mediaTypes?.map((item, index) => (
        <SqMetricChartCard
          key={`${item}-${index}`}
          className="mb-3"
          title={t(`${item}`)}
          metric={metric?.[item]}
          percentage={percent}
          type={metricType}
        />
      ))}
      <CampaingMediaReachComponent campaign={campaign} metricType={metricType} socialId={socialId} />
    </div>
  )
}
